import {rgba} from 'polished';
import styled from 'styled-components';

export const Container = styled.section`
    align-items: flex-start;
    display: flex;
    flex-wrap: nowrap;
    font-family: ${({theme}) => theme.font?.family?.primary};
    font-size: 12px;
    line-height: 14px;
`;

export const CategoryList = styled.div`
    display: flex;
    line-height: 14px;
    max-width: 70%;
`;

const BaseLink = styled.a`
    display: inline-block;
    text-decoration: none;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;

const BaseDiv = styled.div`
    display: inline-block;
    text-decoration: none;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;

export const CategoryLink = styled(BaseLink)`
    color: ${({theme}) => theme.color?.breadcrumb || rgba('#000000', 0.265)};
    flex-shrink: 1;
    min-width: 0;

    &:first-child {
        flex-shrink: 0;
        flex-basis: content;
        flex-basis: auto;
    }
`;

export const CategorySeparator = styled.span`
    color: ${({theme}) => theme.color?.breadcrumb || rgba('#000000', 0.265)};
    display: inline-block;
    margin: 0 5px;
    opacity: 0.5;
    white-space: pre-wrap;
`;

export const StoryCrumb = styled(BaseDiv)`
    color: ${({theme}) => theme.color?.primary || '#000000'};
    flex: 1 0 30%;
    font-weight: 900;
`;
